// extracted by mini-css-extract-plugin
export default {"container":"Yp-z","brandName":"Zp-z","productName":"_p-z","productNamePdpEnhancements":"aq-z","breakLongProductName":"bq-z"};